import { render } from "./HomeCustom.vue?vue&type=template&id=03b491de"
const script = {}
script.render = render

export default script